import { ProductCategoryCodeKeyword } from "@/types"

import { API_URL_CATALOG } from "../urls"

export const getCategoriesKidsApi = async (type: ProductCategoryCodeKeyword) =>
  window.axios
    .get(API_URL_CATALOG + `product/category/list/v1/get?productCategoryCodeKeyword=${type}`)
    .then(({ data }) => {
      if (data.code === "OC_OK") return data.createdEntity.listOfProductCategory
      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })
